export let KudosType = /*#__PURE__*/function (KudosType) {
  KudosType["INDIVIDUAL"] = "individual";
  KudosType["TEAM"] = "team";
  return KudosType;
}({});
export let FlagEventType = /*#__PURE__*/function (FlagEventType) {
  FlagEventType["KUDOS_CREATED"] = "kudos-created";
  FlagEventType["KUDOS_FAILED"] = "kudos-failed";
  FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
  FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
  FlagEventType["DIRTY"] = "dirty";
  FlagEventType["CLOSE"] = "close";
  return FlagEventType;
}({});
export const isFlagEventTypeValue = value => {
  return Object.values(FlagEventType).includes(value);
};